export const STATION_NARRATIVE_TIMEOUT = 30000; // 30 seconds
export const THUMBPRINT_RADIO_TIMEOUT = 5000; // 5 seconds
export const TUNER_INITIALIZATION_FADE_DURATION = 1500;
export const SKIP_TRACK_SPINNER_DELAY = 300;
